import { PortfolioExternalAccount } from '@models/clients/portfolioExternalAccount';
import { ClientCRMRepo } from '@services/clients/clientCRM.repo';
import { extractErrorMessage } from '@common/utils/errorUtils';

export class AddPortfolioExternalAccountModalController {
    public client: any;
    public portfolioExternalAccount: Partial<PortfolioExternalAccount> = {};
    public dropdownOptions: any = {};
    public existingAccounts: PortfolioExternalAccount[] = [];
    public isEditMode: boolean = false;
    public isLoading: boolean = false;
    public title: string = 'Add Portfolio External Account';
    public acceptButtonText: string = 'Save';
    public cancelButtonText: string = 'Cancel';

    public fieldErrors: { [key: string]: boolean } = {};
    public showValidationErrors: boolean = false;
    public saveError: string | null = null;

    /** CDS / trade account number (text); persisted via API on save */
    public cdsAccountNumber: string = '';

    /** @ngInject */
    constructor(
        private $mdDialog: angular.material.IDialogService,
        private clientCRMRepo: ClientCRMRepo
    ) {}

    public $onInit(): void {
        if (this.portfolioExternalAccount && this.portfolioExternalAccount.id) {
            this.isEditMode = true;
            this.title = 'Edit Portfolio External Account';
            this.cdsAccountNumber = this.portfolioExternalAccount.tradeAccountNumber || '';
        } else {
            this.portfolioExternalAccount = {
                selected: false,
                isActive: true
            } as Partial<PortfolioExternalAccount>;
            this.cdsAccountNumber = '';
        }
    }

    public handleAccept(): void {
        this.saveError = null;
        if (!this.validateForm()) {
            this.showValidationErrors = true;
            return;
        }

        if (!this.client || !this.client.id) {
            this.saveError = 'Client is not available.';
            return;
        }

        const payload: any = {
            id: this.portfolioExternalAccount.id || 0,
            accountNumber: this.portfolioExternalAccount.accountNumber,
            accountSourceId: this.portfolioExternalAccount.accountSourceId,
            inception: this.portfolioExternalAccount.inception || 0,
            inceptionDate: this.portfolioExternalAccount.inceptionDate,
            inceptionCurrencyId: this.portfolioExternalAccount.inceptionCurrencyId,
            portfolioId: this.portfolioExternalAccount.portfolioId,
            isActive: this.portfolioExternalAccount.isActive !== false,
            cdsAccountNumber: this.shouldShowTradeAccountField()
                ? (this.cdsAccountNumber || '').trim()
                : undefined
        };

        this.isLoading = true;
        this.clientCRMRepo
            .savePortfolioExternalAccount(this.client.id, payload)
            .then((response: angular.IHttpResponse<any>) => {
                this.isLoading = false;
                this.$mdDialog.hide(response.data);
            })
            .catch((error: any) => {
                this.isLoading = false;
                this.saveError = extractErrorMessage(error, 'Save failed');
            });
    }

    public handleCancel(): void {
        this.$mdDialog.cancel();
    }

    private validateForm(): boolean {
        this.fieldErrors = {};
        if (!this.portfolioExternalAccount.accountNumber || this.portfolioExternalAccount.accountNumber.trim() === '') {
            this.fieldErrors['accountNumber'] = true;
        }
        if (!this.portfolioExternalAccount.accountSourceId) {
            this.fieldErrors['accountSourceId'] = true;
        }
        return Object.keys(this.fieldErrors).length === 0;
    }

    public isFieldInvalid(fieldName: string): boolean {
        return this.showValidationErrors && this.fieldErrors[fieldName];
    }

    public externalSourceOptions(): any[] {
        const list = (this.dropdownOptions && this.dropdownOptions.externalsource) || [];
        return list.filter((o: any) => o.displayName !== 'CDS' && o.name !== 'CDS');
    }

    public shouldShowTradeAccountField(): boolean {
        if (!this.portfolioExternalAccount || !this.portfolioExternalAccount.accountSourceId) {
            return false;
        }
        const selectedSource = (this.dropdownOptions.externalsource || []).find(
            (option: any) => option.id === this.portfolioExternalAccount.accountSourceId
        );
        return !!(selectedSource && selectedSource.displayName !== 'CDS');
    }

    public getAssociatedTradeAccountNumber(): string | null {
        return null;
    }

    public hasTradeAccountSuggestion(): boolean {
        return false;
    }
}

export const AddPortfolioExternalAccountModalComponent: angular.IComponentOptions = {
    template: require('./add-portfolio-external-account-modal.html'),
    controller: AddPortfolioExternalAccountModalController,
    controllerAs: '$ctrl',
    bindings: {
        client: '<',
        portfolioExternalAccount: '<',
        dropdownOptions: '<',
        existingAccounts: '<'
    }
};



// WEBPACK FOOTER //
// ./src/app/clients/clients.details/account-reference/modals/add-portfolio-external-account-modal.ts